<template>
    <BreadCrumb PageTitle="Liste des paiements" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/Paiement/ListePaiement.vue";
    export default defineComponent({
      name: "ListePaiementPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>